import { CreateReportButton } from "@/components/CreateReportButton";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { isStoreLevel } from "@/lib/roles";
import { ShieldCheck, Boxes, Wrench, Briefcase } from "lucide-react";
import HygieneHub from "@/pages/hygiene/HygieneHub";
import Inventaire from "@/pages/metier/Inventaire";
import Maintenance from "@/pages/Maintenance";
import StoreMaintenance from "@/pages/metier/StoreMaintenance";

export const METIER_TABS = [
  { k: "hygiene", label: "HACCP", icon: ShieldCheck, testid: "metier-tab-hygiene" },
  { k: "inventaire", label: "Inventaire", icon: Boxes, testid: "metier-tab-inventaire" },
  { k: "maintenance", label: "Maintenance", icon: Wrench, testid: "metier-tab-maintenance" },
];

export default function Metier() {
  const { tab = "hygiene" } = useParams(); const navigate = useNavigate(); const { user } = useAuth();
  const store = isStoreLevel(user);
  useEffect(() => { if (!METIER_TABS.some(t => t.k === tab)) navigate("/metier/hygiene", { replace: true }); }, [tab, navigate]);
  return (
    <div data-testid="metier-page" className="space-y-4">
      <div className="flex flex-col sm:flex-row sm:items-end gap-3">
        <div className="flex-1 min-w-0"><div className="text-[11px] font-bold text-blue-600 flex items-center gap-1"><Briefcase className="w-3.5 h-3.5"/> Métier</div><h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">Métier</h1><CreateReportButton module="qualite" className="mt-2 ml-2"/></div>
        <div className="flex gap-1 rounded-xl bg-slate-100 p-1 self-start" data-testid="metier-tabs">
          {METIER_TABS.map(t => <button key={t.k} data-testid={t.testid} onClick={() => navigate(`/metier/${t.k}${t.k === "hygiene" ? "/cockpit" : ""}`)} className={`h-9 px-3 sm:px-4 rounded-lg text-xs sm:text-sm font-bold flex items-center gap-1.5 transition-colors ${tab === t.k ? "bg-white text-slate-900 shadow" : "text-slate-500 hover:text-slate-800"}`}><t.icon className="w-4 h-4"/>{t.label}</button>)}
        </div>
      </div>
      <div className="relative">
        {tab === "hygiene" && <div className="mt-4 md:mt-6"><HygieneHub basePath="/metier/hygiene"/></div>}
        {tab === "inventaire" && <Inventaire/>}
        {tab === "maintenance" && (store ? <StoreMaintenance/> : <div className="-m-4 md:-m-6"><Maintenance/></div>)}
      </div>
    </div>
  );
}
